import React from 'react';
import PropTypes from 'prop-types';

const ScreenSwitcher = ({ currentScreen, screensCount, setScreen }) => {
  const result = [];

  for (let screen = 1; screen <= screensCount; screen += 1) {
    const onClick =
      currentScreen !== screen ? { onClick: () => setScreen(screen) } : null;

    const classList = ['screen-switcher'];

    if (currentScreen === screen) {
      classList.push('screen-switcher--active');
    }

    result.push(
      <button
        key={`${currentScreen}_${screen}`}
        className={classList.join(' ')}
        type="button"
        {...onClick}
      >
        <span className="screen-switcher__count">{screen}</span>
        <span>экран</span>
      </button>,
    );
  }

  return <div className="scheme-screen__aside">{result}</div>;
};

ScreenSwitcher.propTypes = {
  currentScreen: PropTypes.number.isRequired,
  screensCount: PropTypes.number.isRequired,
  setScreen: PropTypes.func.isRequired,
};

export default ScreenSwitcher;
